import { render, staticRenderFns } from "./EquipmentDocumentsListComponent.vue?vue&type=template&id=63bbcb48&"
import script from "./EquipmentDocumentsListComponent.vue?vue&type=script&lang=js&"
export * from "./EquipmentDocumentsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports